import React from 'react';
import ReactTooltip from 'react-tooltip';
import { getComputedCSSVariable } from '../../../utils/cssVariableHelpers';
import NoteSVG from '../admin-dashboard-tables/assets/NoteSVG';

interface Props {
  objectID: string,
  notes: string,
}

const NotesTooltip:React.FC<Props> = ({
  objectID,
  notes,
}) => {
  return (
    <>
      <a
        data-tip
        className="profiles btn btn-admin-button-gray d-flex align-items-center justify-content-center p-0"
        data-place="top"
        data-for={`${objectID}`}
      >
        <NoteSVG />
      </a>
      <ReactTooltip
        id={`${objectID}`}
        aria-haspopup={true}
        place="right"
        delayHide={500}
        effect="solid"
        type="success"
        backgroundColor="white"
        border={true}
        borderColor={getComputedCSSVariable('primary')}
        className="hover-tool-tip-profiles border-blue-400"
      >
        <p className="text-truncate notes text-table-light-gray">{notes}</p>
      </ReactTooltip>
    </>
  );
};

export default NotesTooltip;
